module.exports = __webpack_public_path__ + "media/svg/sn-aed5f269.svg";